export function insertSvgPagination() {
    let svg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M6.66667 13.0255L7.69133 14L14 8L7.69133 2L6.66667 2.97452L11.2497 7.33333H2V8.66667H11.2497L6.66667 13.0255Z" fill="#36BEDD"/>\n' +
        '</svg>';
    let pagination = $('.pagination');
    let linkPrev = pagination.find('.previouspostslink');
    let linkNext = pagination.find('.nextpostslink');
    if (linkPrev) {
        linkPrev.append(svg);
    }
    if (linkNext) {
        linkNext.append(svg);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/insertSvgPagination.js